module.exports = __webpack_public_path__ + "static/img/banner-03@1x.829748c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner-03@1x.png
// module id = 158
// module chunks = 1